import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO } from "@/lib/brand";
import { SITE } from "@/constants/testIds";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (loc.pathname.startsWith("/admin")) return null;

  return (
    <motion.nav
      data-testid={SITE.navRoot}
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.6 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/85 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-12 py-5">
        <Link to="/" aria-label="RELATABLE — Home" className="flex items-center">
          <img
            src={LOGO.type_white}
            alt="RELATABLE"
            width="277"
            height="35"
            fetchPriority="high"
            decoding="async"
            className="h-5 md:h-6 w-auto select-none"
            draggable={false}
          />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <NavLink data-testid={SITE.navWork} to="/work" className={({ isActive }) =>
            `eyebrow link-line ${isActive ? "text-bone" : "text-fog hover:text-bone"}`}>
            Work
          </NavLink>
          <NavLink data-testid={SITE.navAbout} to="/about" className={({ isActive }) =>
            `eyebrow link-line ${isActive ? "text-bone" : "text-fog hover:text-bone"}`}>
            About
          </NavLink>
          <NavLink data-testid={SITE.navContact} to="/contact" className={({ isActive }) =>
            `eyebrow link-line ${isActive ? "text-bone" : "text-fog hover:text-bone"}`}>
            Contact
          </NavLink>
        </div>

        <Link
          to="/contact"
          data-testid={SITE.navStartProject}
          className="hidden md:inline-flex items-center gap-2 px-5 py-3 bg-bone text-ink eyebrow hover:bg-relatable hover:text-bone transition-colors duration-300"
        >
          Start A Project
          <span className="text-sm">→</span>
        </Link>

        <Link to="/contact" className="md:hidden eyebrow text-bone link-line">
          Start →
        </Link>
      </div>
    </motion.nav>
  );
}
